import TextEditor from 'components/TextEditor/TextEditor';

export default TextEditor;
